<!-- 个人信息 -->
<template>
  <svg
    t="1748246541627"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="12806"
    width="200"
    height="200"
  >
    <path
      d="M547.89 778a228 228 0 0 1 50.84-143.85l-3.31-0.71-1.67-33.27v-75.7s48.12-32.15 54.39-79.71c2.41-0.15 4.94-0.35 8-0.77 34.6-4.4 59.83-93.78 59.83-93.78s1.67-41.67-19.29-41.67c-2.36 0-25.83 0.31-27.75 1l5.38-74 0.56-15.87s0.41-153.88-179.22-155.57c-186.37 1.69-151.5 84.42-151.5 84.42 0 0.2 0.07 0.41 0.07 0.51-23.24 14-34.94 35.53-34.94 79.29 0 70.14 6.2 85.21 9.47 88.27l-24.26-8s-30.05 3.13-27.51 39.93 32.19 91.12 66.8 95.52c2.61 0.31 4.89 0.52 7 0.72 0.1 58 48.63 81.24 48.63 81.24l0.43 72.23-64.94 35.07L133 696.82s-69.41 21.56-69 111.65l1.28 146H631A228.7 228.7 0 0 1 547.89 778z"
      fill="#00BEB4"
      p-id="12807"
    />
    <path
      d="M776.61 593.37c-101.28 0-183.39 82-183.39 183.26S675.33 959.9 776.61 959.9 960 877.84 960 776.63s-82.11-183.26-183.39-183.26z m111.8 157.77C851.79 788.3 780.07 859.58 751 888.47a18 18 0 0 1-25.49 0c-20.77-20.71-60.66-60.74-71.36-73.24-24.09-28.11-11.29-40.61 1.4-54.78 24.45-27.23 36.5-11 49.76 3.84s22.4 24.87 30.31 33.62c37.67-33.38 56.3-51.2 104.94-92.49 26.13-22.12 38.18-10.71 46.07-3.89 11.84 10.09 29.04 26.67 1.78 49.61z"
      fill="#00BEB4"
      p-id="12808"
    />
  </svg>
</template>
